/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "No vender o compartir mi información personal",
      "Bumble Date",
      "Nuestras aplicaciones",
      "Sobre nosotros",
      "Empleo",
      "Contacto",
      "Inversores",
      "Nuestra Tienda",
      "Empresa",
      "Descargar la aplicación",
      "Accesibilidad en Bumble",
      "Normas",
      "Gestionar cookies",
      "Ley de esclavitud moderna",
      "Aviso de recopilación",
      "Política de privacidad",
      "Términos y condiciones",
      "Legal",
      "Política de privacidad de datos de salud del consumidor de Washington",
      "Escaneá el código QR para conseguir la app de Bumble",
      "Terminar contratos acá",
      "Cerrá el menú",
      "Abrí el menú",
      "Selección de idioma",
      "Pie de página",
      "Accesibilidad en Bumble",
      "Apple y el logotipo de Apple son marcas comerciales de Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Empleo",
      "Google Play es una marca de Google LLC.",
      "Reglas",
      "Inversores",
      "Gestionar cookies",
      "Declaración sobre la Modern Slavery Act",
      "Aviso de recopilación",
      "Política de privacidad",
      "Consejos sobre citas por temporada",
      "Condiciones de Uso",
      "La aplicación",
      "Política de privacidad de datos de salud del consumidor de Washington",
      "Acerca de",
      "Embajadores",
      "Hacé nuevas amistades y encontrá tu comunidad",
      "Generá una red de contactos y avanzá en tu carrera profesional",
      "Encontrá una relación, un vínculo casual o algo intermedio",
      "The Buzz",
      "¡Enterate!",
      "Globalizate con el Modo Travel",
      "Cita",
      "Funciones",
      "Compliments",
      "Sorprendé con tus Compliments y marcá la diferencia",
      "Descubrí",
      "Una página personalizada que destaca a las personas más compatibles con vos, actualizada todos los días.",
      "Modo Incógnito",
      "Usá el Modo Incógnito para ocultar tu perfil de tu jefe, familiares o exparejas.",
      "Conexión inmediata",
      "¿Arrancaste la charla en persona en un evento de Bumble? Seguila por la app.",
      "Opening Moves",
      "Usá la opción Opening Moves para que tu conexión te empiece a escribir antes que vos.",
      "Modo No Molestar",
      "Usa el Modo no molestar para tomarte un tiempo. Cuando quieras volver a conocer gente nueva, te esperamos.",
      "SuperSwipe",
      "Si te gustó mucho un perfil, dejá que se sepa gracias a SuperSwipe.",
      "Travel",
      "Encontrá lo que te hace feliz en cualquier lugar del mundo y conectá con gente de todas partes con el Modo travel.",
      "Videollamada",
      "Usá la videollamada y las llamadas de audio para ver si estás listo para que se conozcan en persona.",
      "Aplicación web",
      "Obtené la experiencia de Bumble directamente desde tu navegador.",
      "Conseguí la app de Bumble",
      "BFF",
      "Seguridad",
      "Historias",
      "Asistencia",
      "Nuestra Tienda",
      "Navegación principal",
      "Sorprendé con tus Compliments y marcá la diferencia.",
      "Compliments",
      "Funciones diseñadas para crear un espacio para conexiones reales, respetuosas y profundas.",
      "Ocultá tu perfil de tu jefe, familiares o exparejas.",
      "Modo Incógnito",
      "Usá el Modo No Molestar para tomarte un tiempo.",
      "Modo No Molestar",
      "¿Viste a alguien que te gusta? Que se entere ahora mismo.",
      "SuperSwipe",
      "Explorar la sección Cita",
      "Encontrá lo que te hace feliz y conectá en cualquier lugar.",
      "Modo Travel",
      "Una manera de verse cara a cara sin salir de tu casa.",
      "Videollamadas",
      "Nuestros líderes ayudan a traer los valores de Bumble a sus comunidades en todo el país.",
      "Líderes de la comunidad",
      "Funciones diseñadas para ayudarte a encontrar a quien quieras y compartir lo que te gusta.",
      "Organizá un encuentro grupal o descubrí eventos locales por tu zona.",
      "Plans",
      "Explorar BFF",
      "Todos los consejos y la inspiración que necesitás para encontrar al amor y conocer nuevas amistades.",
      "Consejos e historias para ayudarte a tener las amistades que querés.",
      "Momento para la amistad",
      "Desde Tokio hasta Toronto, conocé las historias de amor que nacieron en Bumble alrededor del mundo.",
      "Historias de amor",
      "Planificá la cita perfecta: donde quieras, cuando quieras, con quien quieras.",
      "Tips de citas según el momento",
      "Explorar la sección Historias",
      "Leer más",
      "Bumble en {{social_network}}",
      "Contacto",
      "Iniciar sesión",
      "(se abre en otra ventana)",
      "Preguntas",
      "Política de cookies",
      "Bumble - El Blog",
      "Empleos",
      "Chat",
      "Ciudades",
      "Gestionar cookies",
      "Copyright © 2006 – presente. Bumble. Todos los derechos reservados.",
      "Informe de confianza para citas",
      "Apple y el logotipo de Apple son marcas comerciales de Apple Inc. {{__EOL__}}Google Play es una marca de Google LLC.",
      "Descargar",
      "Facebook",
      "Seguinos",
      "Centro de Soporte",
      "Instagram",
      "Idioma",
      "LinkedIn",
      "Bumble es parte de Bumble Inc.",
      "Política de privacidad",
      "Centro de Seguridad",
      "Mapa del sitio",
      "Declaración sobre la Ley de Esclavitud Moderna",
      "Términos y condiciones",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "días"
            ],
            "singular": [
                  "día"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mes"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "años"
            ],
            "singular": [
                  "año"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
